
export type AddressInput = {
  country?: string | null
  city?: string | null
  postalCode?: string | null
  address1?: string | null
  address2?: string | null
} | null | undefined

export type AddressOutput = {
  country: string
  city: string
  postalCode: string
  address1: string
  address2: string
} | null

export default function normalizeAddress(input: AddressInput): AddressOutput {
  if (!input) return null

  const clean = (v: unknown) => (v == null ? '' : String(v).trim())

  const fields = {
    country:    clean(input.country),
    city:       clean(input.city),
    postalCode: clean(input.postalCode),
    address1:   clean(input.address1),
    address2:   clean(input.address2),
  }

  const hasAny = Object.values(fields).some(Boolean)
  if (!hasAny) return null

  return fields
}
